import { Link } from 'react-router-dom';
import { Clock, Eye } from 'lucide-react';
import type { HelpArticle } from '@/hooks/useHelp';

interface HelpArticleCardProps {
  article: HelpArticle;
  showCategory?: boolean;
}

export function HelpArticleCard({ article, showCategory = false }: HelpArticleCardProps) {
  const readTime = Math.max(1, Math.ceil(article.content.split(/\s+/).length / 200));

  return (
    <Link
      to={`/help/${article.category_slug}/${article.slug}`}
      className="group block rounded-lg border border-gray-200 bg-white p-5 shadow-sm transition-all hover:shadow-md dark:border-gray-700 dark:bg-card-dark"
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0 flex-1">
          <h3 className="text-base font-semibold text-gray-900 group-hover:text-indigo-600 dark:text-white dark:group-hover:text-indigo-400">
            {article.title}
          </h3>
          <p className="mt-1 text-sm text-gray-600 dark:text-gray-400">{article.excerpt}</p>
          <div className="mt-3 flex items-center gap-4 text-xs text-gray-500 dark:text-gray-500">
            {showCategory && (
              <span className="inline-flex items-center rounded-full bg-gray-100 px-2 py-0.5 font-medium text-gray-700 dark:bg-gray-800 dark:text-gray-300">
                {article.category_title}
              </span>
            )}
            <span className="flex items-center gap-1">
              <Clock className="h-3 w-3" />
              {readTime} min
            </span>
            <span className="flex items-center gap-1">
              <Eye className="h-3 w-3" />
              {article.views_count}
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
}
